module.exports = __webpack_public_path__ + "static/media/71BTSl5sfwL._SL1500_.2580337f.jpg";